import React from 'react';

import Header from '../../Components/Dashboard/Header/Header';
import Groups from '../../Components/Dashboard/Admin/Groups/List';


export default function GroupsPage() {
  return (
    <>
      <Header/>
      <div className="body">
        <Groups/>
      </div>
    </>
  );
}
